export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Detail.vue?vue&type=template&id=40f4caea&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/Detail.vue?vue&type=template&id=40f4caea&scoped=true&
// module id = 352
// module chunks = 1